import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function OneyIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 151.273 48.634'} fontSize={'inherit'} {...props}>
      <g id="Groupe_5347" data-name="Groupe 5347" clipPath="url(#clip-path)">
        <path
          id="Tracé_8385"
          data-name="Tracé 8385"
          d="M115.765,18.417A18.4,18.4,0,0,0,97.521.052c-10.294,0-18.365,8.266-18.365,18.817a19.167,19.167,0,0,0,5.31,13.249A17.77,17.77,0,0,0,97.4,37.756c5.564,0,13.361-2.674,17.068-10.253a1.073,1.073,0,0,0,.1-.242H107.1l-.044.053a12.782,12.782,0,0,1-9.388,4.018A11.953,11.953,0,0,1,86.1,21.5h29.518c.065-.7.146-2.112.146-3.086M86.319,15.489a11.382,11.382,0,0,1,22.27,0ZM58.456,6.254c-6.653,0-10.033,3.566-10.033,10.623v20.9H41.593V16.386A16.446,16.446,0,0,1,43.851,7.5C45.662,4.7,49.959,0,58.456,0,66.93,0,71.241,4.7,73.049,7.5a16.362,16.362,0,0,1,2.243,8.89V37.772H68.467v-20.9c0-7.057-3.361-10.623-10.01-10.623M151.273.008l-14.4,35.127-3.557,8.694-1.966,4.805h-7.1l5.508-13.491L115.048.008h7.5l10.772,26.413L144.118.008ZM18.845,31.35A12.255,12.255,0,0,1,6.658,18.916,12.266,12.266,0,0,1,18.845,6.468,12.279,12.279,0,0,1,31.012,18.916,12.267,12.267,0,0,1,18.845,31.35m0-31.342A18.67,18.67,0,0,0,0,18.914,18.677,18.677,0,0,0,18.843,37.823,18.668,18.668,0,0,0,37.657,18.914,18.661,18.661,0,0,0,18.843.008"
          transform="translate(0 0)"
          fill="#81bc00"
        />
      </g>
    </SvgIcon>
  );
}
